var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.form.lists.nomesDasFuncoes,
      "label": "Função",
      "outlined": "",
      "maxlength": "40",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo da Função",
      "items": _vm.form.lists.tipos,
      "item-text": "descricao",
      "item-value": "id",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.tipo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "tipo", $$v);
      },
      expression: "form.filters.tipo"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarFuncoes();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Incluir",
      "icon": "mdi-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterFuncao();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.ativo`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarFuncao(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Editar",
            "icon": "mdi-pencil",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterFuncao(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Excluir",
            "icon": "mdi-delete",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.excluirFuncao(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.ativo ? 'var(--primary-button-color)' : 'silver'}`,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.alterarStatusFuncao(item);
            }
          }
        })];
      }
    }, {
      key: `item.emUso`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Detalhar Uso',
            "icon": item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
            "color": item.emUso ? 'green' : 'red',
            "small": true,
            "disabled": !item.emUso
          },
          on: {
            "click": function ($event) {
              item.emUso ? _vm.openDialogDetalharUsoFuncao(item) : null;
            }
          }
        })];
      }
    }], null, true)
  })], 1), _vm.dialogVisualizarFuncao.visible ? _c('VisualizarFuncaoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarFuncao.visible,
      "content": _vm.dialogVisualizarFuncao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarFuncao.close();
      }
    }
  }) : _vm._e(), _c('CadastrarEditarFuncaoDialog', {
    attrs: {
      "tipos": _vm.form.lists.tipos,
      "edit": _vm.dialogManterFuncao.edit,
      "visible": _vm.dialogManterFuncao.visible,
      "content": _vm.dialogManterFuncao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterFuncao.close();
      },
      "onSave": function ($event) {
        return _vm.atualizarListasDeFuncoes();
      }
    }
  }), _c('DetalharUsoFuncaoDialog', {
    attrs: {
      "visible": _vm.dialogDetalharUsoFuncao.visible,
      "content": _vm.dialogDetalharUsoFuncao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogDetalharUsoFuncao.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }